// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1632e740","453":"743b241b","667":"294066b7"}[chunkId] + ".chunk.js";
};